// extracted by mini-css-extract-plugin
export default {"container":"PrestationsPage_container__GxfmE","content":"PrestationsPage_content__VY3Eq","contentMobile":"PrestationsPage_contentMobile__k1MKH"};